

export const itemStudentAdded = (data, item) => {
  if (item) {
    const isItemAdded = data?.filter((elem) => elem._id === item.studentId);
    const _id = isItemAdded[0]._id;
    return [_id];
  }

  return [];
};


export const itemAdded = (data, item) => {
  if (item) {
    const isItemAdded = data?.filter((elem) => elem._id === item._id);
    const _id = isItemAdded[0]._id;
    return [_id];
  }

  return [];
}